import React, { useEffect, useState } from 'react'
import FeaturedItems from '../FeaturedItemSection/FeaturedItems'
import FeaturedProductSlider from './FeaturedProductsSlider'
import CbCarouselVertical from '../CbCarouselVertical/CbCarouselVertical';
import useStateRef from 'react-usestateref';
import { APPLICATION_JSON } from '../../middleware/types';
import Helper from '../Helper';

const FeaturedProductsContainer = ({ containerObject, templateName, contentId, dataZone }) => {
    const [productViewType, setProductViewType] = useState(containerObject && containerObject.attributes && containerObject.attributes.productViewType ?  containerObject.attributes.productViewType : "horizontal");
    const [showInSlider, setShowInSlider] = useState(containerObject && containerObject.attributes && containerObject.attributes.showInSlider ?  containerObject.attributes.showInSlider : "false");
    const [productList, setProductList, productListRef] = useStateRef(containerObject && containerObject.results ? containerObject.results : [])
	const [productIds, setProductIds, productIdsRef] = useStateRef(containerObject?.productIds ? containerObject.productIds : []);
    const [containerObjectState, setContainerObjectState, containerObjectStateRef] = useStateRef(containerObject)
	useEffect(()=>{
        console.log('containerObject.disableAjaxCallForCDN in feature',containerObject);
        if(containerObject.disableAjaxCallForCDN == 'N'){
		    getPriceListFromATG();
        }
	},[])

	async function getPriceListFromATG (){
		console.log("getPriceListFromATG......called...",containerObject);
		const inputMap = {
			productIdList : productIdsRef.current,
			searchTerm : ""
		}
		var actionUrl = `api/rest/cb/product/price-list-from-atg`;
	var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
		var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(inputMap))
		console.log('response...error...',res?.productPrices);
		if (res?.responseMessage == "success") {
            let tempResults = productListRef.current;
			console.log("success......????? before...",tempResults);
			tempResults?.map((oneProduct, key)=>{
				if(productIdsRef.current?.includes(oneProduct['product.productId'])){
					const productObj = res?.productPrices[oneProduct['product.productId']];
					Object.entries(productObj).map(([key, value], i) => {
						oneProduct[key] = value;
					  }) 
				}
				
			})
			setProductList(tempResults);
            setContainerObjectState({...containerObjectStateRef.current, results:productListRef.current})
			console.log("success......????? after...",productListRef.current);
            console.log("success......????? after  containerObjectStateRef.current...",containerObjectStateRef.current);

		}
		else {
			console.log('response...error...',res);
		}
	}

    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row featuredProductContainer ${containerObject && containerObject.attributes && containerObject.attributes.className ? containerObject.attributes.className : ""} ${containerObject && containerObject.DO_NOT_DISPLAY	== false ? "featured-dont-display" :""} `} >
            
            

            {productListRef.current && productListRef.current.length >= 1 ? 
                showInSlider === "true" && productViewType === "horizontal" ?
                    <FeaturedProductSlider containerObject={containerObjectStateRef.current ? containerObjectStateRef.current : containerObject} />
                    :
                    showInSlider === "true" && productViewType === "vertical" ?
                        <CbCarouselVertical containerObject={containerObjectStateRef.current ? containerObjectStateRef.current : containerObject} />
                        :
                        <FeaturedItems containerObject={containerObjectStateRef.current ? containerObjectStateRef.current : containerObject} />
                : ""}
        </div>
    )
}
export default FeaturedProductsContainer
